/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { EventGroupsFormComponent } from '@app/events/events-groups/event-groups-form/event-groups-form.component';

@Injectable({
  providedIn: 'root',
})
export class EventGroupsFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open event group form
   * @param eventGroup event group
   */
  public open(eventGroup: null | EventGroup = null): Promise<any> {
    const modal = this.modalService.open(EventGroupsFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.eventGroup = eventGroup;
    return modal.result;
  }
}
